/**
 * Utility functions for parent-side widget manager
 */
export const generateUniqueId = (prefix) => {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
        return `${prefix}-${crypto.randomUUID()}`;
    }
    return `${prefix}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
};
export const getDefaultStyles = (iframeClass, wrapClass) => {
    return `
.${iframeClass} {
  width: 100%;
  border: none;
  display: block;
  min-height: 400px;
  transition: height 0.3s ease-out;
}

.${wrapClass} {
  margin: 0;
  padding: 0;
}
`.trim();
};
export const injectStyles = (css, styleId) => {
    if (document.getElementById(styleId))
        return;
    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = css;
    document.head.appendChild(style);
};
export const debugLog = (debugMode, prefix, ...args) => {
    if (debugMode) {
        console.log(`[${prefix}]`, ...args);
    }
};
